export enum BusinessRoleSortType {
    Id,
    Name,
    IsDeleted
}
